import { render, staticRenderFns } from "./aOwnerDetailAcctReceipt.vue?vue&type=template&id=0d857ff0"
import script from "./aOwnerDetailAcctReceipt.vue?vue&type=script&lang=js"
export * from "./aOwnerDetailAcctReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports